export class BOToothQuoteDetailFace{
  id?:number;
  toothStateDetailId:number;
  toothFaceId:number;
  toothStateId:number;
  color?:string;
  strokeColor?:string;
  comodin?:string;
  toothQuoteDetailId:number;

}
